export const prescriptionForms: Record<string, string> = {
  Applicator: "Applicators",
  Blistor: "Blistors",
  Box: "Boxes",
  Caplet: "Caplets",
  Capsule: "Capsules",
  Each: "Each",
  Film: "Films",
  Gram: "Grams",
  Gum: "Gums",
  Implant: "Implants",
  Insert: "Inserts",
  Kit: "Kits",
  Lozenge: "Lozenges",
  Milliliter: "Milliliters",
  Packet: "Packets",
  Pad: "Pads",
  Patch: "Patches",
  Ring: "Rings",
  Sponge: "Sponges",
  Stick: "Sticks",
  Strip: "Strips",
  Suppository: "Suppositories",
  Swab: "Swabs",
  Tablet: "Tablets",
  Troche: "Troches",
  Unspecified: "Unspecified",
  Wafer: "Wafers",
};

export interface RxChangeAlertForm {
  reasonDenied: string;
  refillNotes: string;
  paInformation: string;
}
